// extracted by mini-css-extract-plugin
module.exports = {"slider-container":"index_slider-container__c9Vfq","slider":"index_slider__J8pO_","slide-container":"index_slide-container__c36dY"};